import Axios from '../../axiosConfig';
import { BACKEND_URL } from '../../config';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import { LocalizedName } from '../../types/localization';

configure({ enforceActions: 'observed' });

export default class InfoModule {
    private info: LocalizedName | null = null;
    private material: LocalizedName | null = null;
    private cookies: LocalizedName | null = null;
    private accessibility: LocalizedName | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public async fetchLocalizedInfoByKey(key: string): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + `info/getLocalizedInfo/${key}`,
            withCredentials: true,
        });
        if (response.status === 200) this.setLocalizedInfo(key, response.data);
    }

    public async saveLocalizedInfoByKey(key: string, localizedName: LocalizedName): Promise<void> {
        const response = await Axios({
            method: 'POST',
            url: BACKEND_URL + `info/saveLocalizedInfo/${key}`,
            data: localizedName,
            withCredentials: true,
        });
        const localizedInfo: LocalizedName = response.data;
        if (response.status === 200) this.setLocalizedInfo(key, localizedInfo);
    }

    private setLocalizedInfo(key: string, localizedInfo: LocalizedName): void {
        switch (key) {
            case 'info':
                runInAction(() => (this.info = localizedInfo));
                break;

            case 'material':
                runInAction(() => (this.material = localizedInfo));
                break;

            case 'accessibility':
                runInAction(() => (this.accessibility = localizedInfo));
                break;

            case 'cookies':
                runInAction(() => (this.cookies = localizedInfo));
                break;
        }
    }

    public get shvkInfo(): LocalizedName | null {
        return this.info;
    }

    public get materialText(): LocalizedName | null {
        return this.material;
    }

    public get cookiesInfo(): LocalizedName | null {
        return this.cookies;
    }

    public get accessibilityStatement(): LocalizedName | null {
        return this.accessibility;
    }
}
